import accordion from '@primevue/themes/nora/accordion';
import autocomplete from '@primevue/themes/nora/autocomplete';
import avatar from '@primevue/themes/nora/avatar';
import badge from '@primevue/themes/nora/badge';
import base from '@primevue/themes/nora/base';
import blockui from '@primevue/themes/nora/blockui';
import breadcrumb from '@primevue/themes/nora/breadcrumb';
import button from '@primevue/themes/nora/button';
import card from '@primevue/themes/nora/card';
import carousel from '@primevue/themes/nora/carousel';
import cascadeselect from '@primevue/themes/nora/cascadeselect';
import checkbox from '@primevue/themes/nora/checkbox';
import chip from '@primevue/themes/nora/chip';
import colorpicker from '@primevue/themes/nora/colorpicker';
import confirmdialog from '@primevue/themes/nora/confirmdialog';
import confirmpopup from '@primevue/themes/nora/confirmpopup';
import contextmenu from '@primevue/themes/nora/contextmenu';
import datatable from '@primevue/themes/nora/datatable';
import dataview from '@primevue/themes/nora/dataview';
import datepicker from '@primevue/themes/nora/datepicker';
import dialog from '@primevue/themes/nora/dialog';
import divider from '@primevue/themes/nora/divider';
import dock from '@primevue/themes/nora/dock';
import drawer from '@primevue/themes/nora/drawer';
import editor from '@primevue/themes/nora/editor';
import fieldset from '@primevue/themes/nora/fieldset';
import fileupload from '@primevue/themes/nora/fileupload';
import floatlabel from '@primevue/themes/nora/floatlabel';
import galleria from '@primevue/themes/nora/galleria';
import iconfield from '@primevue/themes/nora/iconfield';
import iftalabel from '@primevue/themes/nora/iftalabel';
import image from '@primevue/themes/nora/image';
import imagecompare from '@primevue/themes/nora/imagecompare';
import inlinemessage from '@primevue/themes/nora/inlinemessage';
import inplace from '@primevue/themes/nora/inplace';
import inputchips from '@primevue/themes/nora/inputchips';
import inputgroup from '@primevue/themes/nora/inputgroup';
import inputnumber from '@primevue/themes/nora/inputnumber';
import inputotp from '@primevue/themes/nora/inputotp';
import inputtext from '@primevue/themes/nora/inputtext';
import knob from '@primevue/themes/nora/knob';
import listbox from '@primevue/themes/nora/listbox';
import megamenu from '@primevue/themes/nora/megamenu';
import menu from '@primevue/themes/nora/menu';
import menubar from '@primevue/themes/nora/menubar';
import message from '@primevue/themes/nora/message';
import metergroup from '@primevue/themes/nora/metergroup';
import multiselect from '@primevue/themes/nora/multiselect';
import orderlist from '@primevue/themes/nora/orderlist';
import organizationchart from '@primevue/themes/nora/organizationchart';
import overlaybadge from '@primevue/themes/nora/overlaybadge';
import paginator from '@primevue/themes/nora/paginator';
import panel from '@primevue/themes/nora/panel';
import panelmenu from '@primevue/themes/nora/panelmenu';
import password from '@primevue/themes/nora/password';
import picklist from '@primevue/themes/nora/picklist';
import popover from '@primevue/themes/nora/popover';
import progressbar from '@primevue/themes/nora/progressbar';
import progressspinner from '@primevue/themes/nora/progressspinner';
import radiobutton from '@primevue/themes/nora/radiobutton';
import rating from '@primevue/themes/nora/rating';
import ripple from '@primevue/themes/nora/ripple';
import scrollpanel from '@primevue/themes/nora/scrollpanel';
import select from '@primevue/themes/nora/select';
import selectbutton from '@primevue/themes/nora/selectbutton';
import skeleton from '@primevue/themes/nora/skeleton';
import slider from '@primevue/themes/nora/slider';
import speeddial from '@primevue/themes/nora/speeddial';
import splitbutton from '@primevue/themes/nora/splitbutton';
import splitter from '@primevue/themes/nora/splitter';
import stepper from '@primevue/themes/nora/stepper';
import steps from '@primevue/themes/nora/steps';
import tabmenu from '@primevue/themes/nora/tabmenu';
import tabs from '@primevue/themes/nora/tabs';
import tabview from '@primevue/themes/nora/tabview';
import tag from '@primevue/themes/nora/tag';
import terminal from '@primevue/themes/nora/terminal';
import textarea from '@primevue/themes/nora/textarea';
import tieredmenu from '@primevue/themes/nora/tieredmenu';
import timeline from '@primevue/themes/nora/timeline';
import toast from '@primevue/themes/nora/toast';
import togglebutton from '@primevue/themes/nora/togglebutton';
import toggleswitch from '@primevue/themes/nora/toggleswitch';
import toolbar from '@primevue/themes/nora/toolbar';
import tooltip from '@primevue/themes/nora/tooltip';
import tree from '@primevue/themes/nora/tree';
import treeselect from '@primevue/themes/nora/treeselect';
import treetable from '@primevue/themes/nora/treetable';
import virtualscroller from '@primevue/themes/nora/virtualscroller';

export default {
    ...base,
    components: {
        accordion,
        autocomplete,
        avatar,
        badge,
        blockui,
        breadcrumb,
        button,
        datepicker,
        card,
        carousel,
        cascadeselect,
        checkbox,
        chip,
        colorpicker,
        confirmdialog,
        confirmpopup,
        contextmenu,
        dataview,
        datatable,
        dialog,
        divider,
        dock,
        drawer,
        editor,
        fieldset,
        fileupload,
        iftalabel,
        floatlabel,
        galleria,
        iconfield,
        image,
        imagecompare,
        inlinemessage,
        inplace,
        inputchips,
        inputgroup,
        inputnumber,
        inputotp,
        inputtext,
        knob,
        listbox,
        megamenu,
        menu,
        menubar,
        message,
        metergroup,
        multiselect,
        orderlist,
        organizationchart,
        overlaybadge,
        popover,
        paginator,
        password,
        panel,
        panelmenu,
        picklist,
        progressbar,
        progressspinner,
        radiobutton,
        rating,
        ripple,
        scrollpanel,
        select,
        selectbutton,
        skeleton,
        slider,
        speeddial,
        splitter,
        splitbutton,
        stepper,
        steps,
        tabmenu,
        tabs,
        tabview,
        textarea,
        tieredmenu,
        tag,
        terminal,
        timeline,
        togglebutton,
        toggleswitch,
        tree,
        treeselect,
        treetable,
        toast,
        toolbar,
        tooltip,
        virtualscroller
    }
};
